module.exports = __webpack_public_path__ + "static/media/img-goal-15.bca6fa1d.jpg";